import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})

/**
 * Feedback service
 * --------
 * FLOW
 * --------
 * Display a toast message for feedback
 * @deprecated use the toast service instead
 */
export class FeedbackService {
  toastController = inject(ToastController);
  private readonly translateService = inject(TranslateService);

  /**
   * Show toast message
   * @param message message to display
   * @param duration time to show dialog in milliseconds
   * @param showCloseButton true to show the close button
   * @param color dialog background color
   */
  async present(
    message: string,
    duration = 2000,
    showCloseButton = false,
    color = 'medium',
  ) {
    let toast;

    if (showCloseButton) {
      toast = await this.toastController.create({
        message: this.translateService.instant(message),
        duration: duration,
        color: color,
        buttons: [
          {
            side: 'end',
            icon: 'close-circle',
            role: 'cancel',
            handler: () => {
              // TODO: add implementation
            },
          },
        ],
      });
    } else {
      toast = await this.toastController.create({
        message: this.translateService.instant(message),
        duration: duration,
        color: color,
      });
    }

    toast.present();
    return toast;
  }

  /**
   * Dismiss the top toast message
   */
  async dismiss() {
    await this.toastController.dismiss();
  }
}
